export default __webpack_public_path__ + "static/media/hero.6e111fb1.gif";